import type { SVGProps } from 'react';
import * as React from 'react';

const LinkSlashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/link-slash">
      <g id="Icon">
        <path
          d="M4.5834 12.6244C4.93484 12.2732 5.50445 12.2731 5.85586 12.6244C6.20726 12.9758 6.20711 13.5453 5.85586 13.8968L5.14883 14.6039C3.90161 15.8511 3.87336 17.714 5.07754 18.9183C6.28186 20.1226 8.14465 20.0943 9.392 18.847L12.2377 15.9994L13.5111 17.2728L10.6645 20.1195C8.75757 22.0263 5.754 22.1416 3.80411 20.1917C1.85438 18.2419 1.96957 15.2383 3.87637 13.3314L4.5834 12.6244Z"
          fill="currentColor"
        />
        <path
          d="M13.3402 3.86265C15.2471 1.95582 18.2507 1.8405 20.2006 3.79038C22.1504 5.74024 22.0351 8.74385 20.1283 10.6507L19.4213 11.3578C19.0698 11.7088 18.5002 11.709 18.1488 11.3578C17.7975 11.0064 17.7977 10.4368 18.1488 10.0853L18.8559 9.37827C20.1031 8.13098 20.1314 6.26814 18.9272 5.06382C17.7228 3.85952 15.86 3.88782 14.6127 5.13511L10.517 9.22984L14.6107 13.3236C15.0752 12.2258 14.9269 10.7875 13.8109 9.8314C13.4336 9.50809 13.3911 8.93836 13.7143 8.56089C14.0376 8.18347 14.6014 8.14389 14.9789 8.46714C16.9938 10.1931 17.0378 12.8562 15.9438 14.6566L21.1449 19.8578C21.4963 20.2092 21.4964 20.7798 21.1449 21.1312C20.7935 21.4824 20.2229 21.4825 19.8715 21.1312L2.87149 4.1312C2.52008 3.7798 2.52022 3.20925 2.87149 2.85776C3.22296 2.50629 3.79345 2.50629 4.14493 2.85776L9.24453 7.95737L13.3402 3.86265Z"
          fill="currentColor"
        />
        <path
          d="M9.46426 13.2259C9.63388 13.5604 9.87466 13.8745 10.1947 14.1488C10.5722 14.4721 10.6155 15.0428 10.2924 15.4203C9.96906 15.7977 9.39841 15.8431 9.0209 15.5199C7.6198 14.3197 7.17243 12.6639 7.39883 11.1605L9.46426 13.2259Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default LinkSlashIcon;
